import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSelectionList } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/app.states';
import { Job } from '@app/shared/models/job';
import { Offer } from "@app/shared/models/offer";
import { CopyOffer, UpdateOffer } from '@app/store/actions/offer.actions';

//import { listTransition } from '@app/core';

@Component({
  selector: 'app-copy-offer-dialog',
  templateUrl: './copy-offer-dialog.component.html',
  styleUrls: ['./copy-offer-dialog.component.scss'],
//animations: [ listTransition ]
})
export class CopyOfferDialogComponent implements OnInit {

  jobs:Job[];
  success:boolean = false;
  offer:Offer;

  @ViewChild('selectedJobs')
  private selectedJobs: MatSelectionList;

  constructor(
    public dialogRef: MatDialogRef<CopyOfferDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    private fb: FormBuilder,
    private store:Store<AppState>,
  ) {

    this.jobs = data.jobs;
    this.offer = data.offer;

  }

  ngOnInit() {
  }

  onSubmit(){
    //this.success = true;
    let options = this.selectedJobs.selectedOptions.selected;

    let jobs = []
    for(let opt of options){
      jobs.push(opt.value);
    }

    if(jobs.length){
      let offer = new Offer();
      offer.uuid = this.offer.uuid;
      const payload = {offer:offer,jobs:jobs};
      this.store.dispatch(new CopyOffer(payload));
    }
  }

  close():void{

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/copy-offer-dialog/copy-offer-dialog.component.ts